import { apiRequest } from './httpClient';

// A user's own companies (organizations they have meetings with) -
// backend/routers/companies.py. Every route there is already scoped to
// the authenticated caller, so no user id is ever passed here.
export function getCompanies() {
  return apiRequest('/api/companies');
}

export function createCompany({ name, domain }) {
  return apiRequest('/api/companies', {
    method: 'POST',
    body: {
      name,
      ...(domain ? { domain } : {}),
    },
  });
}

// Informational counts only (never memory text, documents, or action
// item content) - lets the meeting-creation UI show "AI context
// available" for the selected company without loading its full memory.
export function getCompanyContextPreview(companyId) {
  return apiRequest(`/api/companies/${companyId}/context-preview`);
}
